/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AnswerOptionModel,
  NotFoundExceptionModel,
  UnauthorizedExceptionModel,
  UpdateAnswerOptionModel,
  ValidationExceptionModel,
} from './data-contracts'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class AnswerOption<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags AnswerOption
   * @name GetAnswerOption
   * @request GET:/api/AnswerOption/{answerOptionId}
   * @secure
   */
  getAnswerOption = (answerOptionId: string, params: RequestParams = {}) =>
    this.request<AnswerOptionModel, NotFoundExceptionModel>({
      path: `/api/AnswerOption/${answerOptionId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags AnswerOption
   * @name UpdateAnswerOption
   * @request PUT:/api/AnswerOption/{answerOptionId}
   * @secure
   */
  updateAnswerOption = (
    answerOptionId: string,
    data: UpdateAnswerOptionModel,
    params: RequestParams = {},
  ) =>
    this.request<
      AnswerOptionModel,
      ValidationExceptionModel | NotFoundExceptionModel
    >({
      path: `/api/AnswerOption/${answerOptionId}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
  /**
   * No description
   *
   * @tags AnswerOption
   * @name DeleteAnswerOption
   * @request DELETE:/api/AnswerOption/{answerOptionId}
   * @secure
   */
  deleteAnswerOption = (answerOptionId: string, params: RequestParams = {}) =>
    this.request<void, UnauthorizedExceptionModel | NotFoundExceptionModel>({
      path: `/api/AnswerOption/${answerOptionId}`,
      method: 'DELETE',
      secure: true,
      ...params,
    })
}
